// extracted by mini-css-extract-plugin
export var calendarView = "_ij-0";